export function getMinMaxCoordinates(cities) {
  let minLat = Infinity;
  let maxLat = -Infinity;
  let minLong = Infinity;
  let maxLong = -Infinity;

  cities.forEach((city) => {
    const [long, lat] = city.coordinates;
    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
    if (long < minLong) minLong = long;
    if (long > maxLong) maxLong = long;
  });

  return {
    minLat,
    maxLat,
    minLong,
    maxLong,
  };
}

export function getMapBounds(coordinates) {
  //   const bounds = L.latLngBounds();
  //   coordinates.forEach(([lng, lat]) => {
  //     bounds.extend(L.latLng(lat, lng));
  //   });
  //   return bounds;
}

function removeImagePattern(text) {
  return text.replace(
    /!\[image(?:-\d+)?\.png\]\(attachment:image(?:-\d+)?\.png\)/g,
    ""
  );
}

export function extractSqlQueryFromText(LongInputText) {
  let extractedData = LongInputText.split("\n```");
  let result = null;

  if (extractedData.length === 1) {
    result = {
      queryText: null,
      normalText: removeImagePattern(extractedData[0]),
    };
  } else {
    result = {
      queryText: extractedData[1],
      normalText: removeImagePattern(extractedData[2]),
    };
  }
  return result;
}
